import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { FaRegEye } from "react-icons/fa";
import { FaRegEyeSlash } from "react-icons/fa";
import { TfiStatsDown, TfiStatsUp } from "react-icons/tfi";
import { FiUser } from "react-icons/fi";
import { IoStar } from "react-icons/io5";

import "./Home.scss";
import { useDispatch, useSelector } from "react-redux";
import ROUTES from "../../constants/routes";
import CustomButton from "../../components/CustomButton/CustomButton";
import BarChart from "../Analytics/Charts/BarChart/BarChart";
import { useViewPortDetector } from "../../helpers/viewPortDetector";
import { updateOpenSupport } from "../../redux/features/user-slice";

const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;
const colors = ["#65C1E8"];

const Home = ({ profile }) => {
  const { currentViewPort } = useViewPortDetector();
  const dispatch = useDispatch();
  const {
    currency,
    id: organization_id,
    name: organization_name,
    subscription,
  } = useSelector((state) => state.organizationReducer.value);

  const { salesData, productData, customerData } = useSelector(
    (state) => state.homeReducer.value
  );

  const navigate = useNavigate();

  const [hideContents, setHideContents] = useState(false);
  const [totalRevenue, setTotalRevenue] = useState(0);

  const [defaultFont, setDefaultFont] = useState(35);

  useEffect(() => {
    if (currentViewPort === "desktop") {
      setDefaultFont(65);
    } else {
      setDefaultFont(35);
    }
  }, [currentViewPort]);

  const [data, setData] = useState({
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: colors,
        borderWidth: 0,
      },
    ],
  });

  useEffect(() => {
    const labels = [];

    const dataSet = [];

    let total_week_revenue = 0;

    salesData?.salesData?.revenue_by_day?.forEach((el) => {
      total_week_revenue += el?.total_revenue || 0;
      labels.push(el?.day_short || "N/A");
      dataSet.push(el?.total_revenue);
    });

    setData({
      labels: labels,
      datasets: [
        {
          data: dataSet,
          backgroundColor: colors,
          borderWidth: 0,
        },
      ],
    });
    setTotalRevenue(Number(total_week_revenue).toFixed(2));
  }, [salesData]);

  const handleOpenSupport = () => {
    if (currentViewPort === "desktop") {
      dispatch(updateOpenSupport({ open_support: "support" }));
    }
  };
  return (
    <div className="home-page">
      {!profile && (
        <div className="desktop-navbar box-shadow">
          <p>{organization_name}</p>
        </div>
      )}
      <div className="home-page-wrapper">
        <div className="home-column-container">
          <div className="top-container">
            <div
              className="eye-icon desktop"
              onClick={() => {
                setHideContents((state) => !state);
              }}
            >
              {hideContents ? <FaRegEye /> : <FaRegEyeSlash />}
            </div>
            <p className="date">
              <span>Current Stats</span> <span className="border">Today</span>
            </p>
            <div className="contents">
              <div>
                <span className="desktop">Sales</span>
                <p
                  style={{
                    fontSize: `${
                      salesData?.todayData?.total_revenue_today && !hideContents
                        ? Math.max(
                            16,
                            salesData.todayData.total_revenue_today.toString()
                              .length < 6
                              ? defaultFont
                              : defaultFont -
                                  salesData.todayData.total_revenue_today.toString()
                                    .length *
                                    2
                          )
                        : defaultFont
                    }px`,
                    transition: "font-size 0.2s ease-in-out",
                  }}
                >
                  {!hideContents
                    ? `${currency || "$"}${
                        salesData?.todayData?.total_revenue_today || "0.00"
                      }`
                    : `${currency || "$"}XX`}
                </p>
                <span className="mobile">Sales revenue</span>
                <span className="desktop last">Revenue</span>
              </div>
              <div>
                <span className="desktop">Products</span>
                <p>
                  {!hideContents
                    ? `${
                        salesData?.todayData?.total_products_sold_today || "0"
                      }`
                    : `${"XX"}`}
                </p>
                <span className="mobile">Products sold</span>
                <span className="desktop last">Sold</span>
              </div>
            </div>
            <CustomButton
              name={"Add New Sale"}
              type={"button"}
              color={"primary"}
              bigButton={true}
              handleSubmit={() => {
                navigate(ROUTES.checkout.path);
              }}
              disabled={false}
            />
          </div>

          <div className="overall-contents">
            <div className="home-row-container">
              <div className="home-sales home-container">
                {totalRevenue > 0 ? (
                  <div className="top-sales">
                    <p>Sales Analytics</p>
                    <Link to={ROUTES.checkout.path}>Sell Product</Link>
                  </div>
                ) : (
                  <p className="title">Sales log</p>
                )}
                {totalRevenue > 0 ? (
                  <div className="home-sales-analytics">
                    <div className="left">
                      <BarChart data={data} />
                    </div>
                    <div className="right">
                      <div>
                        <span>Revenue This Week</span>
                        <p>
                          {currency || "$"}
                          {hideContents
                            ? "XX.XX"
                            : salesData?.todayData?.total_revenue_this_week}
                          <span
                            className={
                              parseFloat(
                                salesData?.salesData?.total_revenue_increase
                              ) < 0
                                ? "danger"
                                : ""
                            }
                          >
                            {salesData?.salesData?.total_revenue_increase <
                            0 ? (
                              <TfiStatsDown />
                            ) : (
                              <TfiStatsUp />
                            )}
                            {salesData?.salesData?.total_revenue_increase ||
                              "0.00"}
                            %
                          </span>
                        </p>
                      </div>
                      <Link to={ROUTES.analytics.path}>View More</Link>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="middle">
                      <img src="/images/home/sales.svg" alt="" aria-label="Sales Section" />
                      <div className="contents">
                        <p>
                          Record your <span>sales</span> to digitalize your
                          business and record your transactions for better
                          transparency
                        </p>

                        <Link to={ROUTES.checkout.path}>Sell Product</Link>
                      </div>
                    </div>
                    <p className="bottom">
                      Don't worry, you can try selling for testing and cancel
                      the sale later from Menu {">"} Sales
                    </p>
                  </>
                )}
              </div>
              <div className="home-products home-container">
                {productData?.products?.length ? (
                  <div className="top-products">
                    <div className="left">
                      <span>#Featured</span>
                      <p className="title">Products</p>
                    </div>
                    <Link to={ROUTES.addProduct.path}>Add Products</Link>
                  </div>
                ) : (
                  <p className="title">Products</p>
                )}
                {productData?.products?.length ? (
                  <div className="products-list">
                    {productData?.products?.map((item, i) => {
                      return (
                        <div className="item" key={i}>
                          <div className="image">
                            <p>
                              {`${item?.name}`.length > 0
                                ? `${item?.name}`[0]
                                : "P"}
                            </p>
                            {item?.image && (
                              <img
                                src={`${IMAGE_URL}${item.image}`}
                                alt="" aria-label={`${item?.name || "Product"}'s Image`}
                              />
                            )}
                          </div>
                          <p className="name">{item?.name}</p>
                          <span>
                            {currency || "$"}
                            {parseFloat(item?.reduced_price) > 0
                              ? item?.reduced_price
                              : item?.price}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="middle">
                    <img src="/images/home/product.svg" alt="" aria-label="Product Section" />
                    <div className="contents">
                      <p className="heading">
                        Let's start by creating your first product?
                      </p>

                      <p>It's simple: all you need is a name and a price</p>

                      <Link to={ROUTES.addProduct.path}>Add Product</Link>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="home-row-container">
              <div className="home-orders home-container">
                {salesData?.orderData > 0 && (
                  <div className="top-orders">
                    <div className="left">
                      <p>{salesData?.orderData || 0}</p>
                      <span>Orders this week</span>
                    </div>
                    <Link to={ROUTES.orders.path}>View Orders</Link>
                  </div>
                )}
                <p className="title">Orders</p>
                <div className="middle">
                  <div className="contents">
                    <p className="heading">
                      You can create orders for deliveries too!
                    </p>

                    <p>
                      DaikoFin helps you register orders that are out for
                      deliveries and payments have not been received yet.
                    </p>

                    <Link to={ROUTES.checkout.path}>Create Order</Link>
                  </div>
                  <img src="/images/home/order.svg" alt="" aria-label="Order Section" />
                </div>
              </div>

              {customerData?.total_customers > 0 && (
                <div className="home-customer">
                  <div className="top">
                    <div className="svg">
                      <FiUser />
                      <IoStar className="star" />
                    </div>
                    <Link to={ROUTES.customers.path}>View Customers</Link>
                  </div>
                  <div className="bottom">
                    <div className="left">
                      <span>Total Customers</span>
                      <p>{customerData?.total_customers || 0}</p>
                    </div>
                    <div className="right">
                      <p>
                        <span
                          className={
                            parseFloat(customerData?.change_month) < 0
                              ? "danger"
                              : ""
                          }
                        >
                          {parseFloat(customerData?.change_month) < 0 ? (
                            <TfiStatsDown />
                          ) : (
                            <TfiStatsUp />
                          )}
                          {customerData?.change_month}
                          {" %"}
                        </span>{" "}
                        vs Last month
                      </p>
                      <p>
                        <span
                          className={
                            parseFloat(customerData?.change_week) < 0
                              ? "danger"
                              : ""
                          }
                        >
                          {parseFloat(customerData?.change_week) < 0 ? (
                            <TfiStatsDown />
                          ) : (
                            <TfiStatsUp />
                          )}
                          {customerData?.change_week}
                          {" %"}
                        </span>{" "}
                        vs Last week
                      </p>
                      <p>
                        <span
                          className={
                            parseFloat(customerData?.change_today) < 0
                              ? "danger"
                              : ""
                          }
                        >
                          {parseFloat(customerData?.change_today) < 0 ? (
                            <TfiStatsDown />
                          ) : (
                            <TfiStatsUp />
                          )}
                          {customerData?.change_today}
                          {" %"}
                        </span>{" "}
                        vs Yesterday
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {!profile && (
          <div className="home-column-container reverse">
            <div className="overall-contents">
              <div className="home-support">
                <img src="/images/home/support.svg" alt="" aria-label="Support Section" />
                <p className="title">Support</p>
                <div className="right">
                  <p>
                    <span>Our support team is ready to</span> guide you through
                    your queries
                  </p>
                  <Link
                    to={
                      currentViewPort === "desktop" ? "#" : ROUTES.support.path
                    }
                    onClick={handleOpenSupport}
                  >
                    Talk to Support Team {">"}
                  </Link>
                </div>
              </div>

              <div className="home-upgrade">
                <div className="top">
                  <img
                    src="/images/home/upgrade.svg"
                    alt="" aria-label="Subscription Section"
                  />
                  {subscription?.plan?.product?.name !== "Ultra" ? (
                    <p>
                      Ready to Go{" "}
                      {subscription?.plan?.name === "Pro"
                        ? "Plus"
                        : subscription?.plan?.name === "Free"
                        ? "Pro"
                        : "Ultra"}{" "}
                      and Be Happier?
                    </p>
                  ) : (
                    <p>
                      Your organization is subscribed to <span>Ultra</span> Plan
                    </p>
                  )}
                </div>
                <span>
                  Get even more perks for your team or enterprise—any business,
                  any size. Like enhanced licenses, multiple users, and more.
                </span>

                <Link to={ROUTES.upgrade.path}>UPGRADE NOW</Link>
              </div>
            </div>
          </div>
        )}
      </div>

      <div
        className="eye-icon"
        onClick={() => {
          setHideContents((state) => !state);
        }}
      >
        {hideContents ? <FaRegEye /> : <FaRegEyeSlash />}
      </div>
      <p className="navbar-title-home">{organization_name || "Home"}</p>
    </div>
  );
};

export default Home;
